import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.EM001.error_id: {
            return (
                <>
                    <ResultText>
                        Encroachment Method 1 is not used in the following {row?.data?.length} cross sections.
                    </ResultText>
                    <ResultText>
                        <CheckCSName csNameList={row.data.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
        case MessageCodes.Internal.EM000.error_id: {
            return (
                <>
                    <ResultText>
                        {row.error_message}
                    </ResultText>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}


export const B3 = {
    RenderDescription,
}